<template>
	<div>
		<v-row
			wrap
		>
			<v-col
				class="d-flex"
				xs12
				sm6
			>
				<v-btn
					block
					variant="outlined"
					@click="byEan = true"
				>
					<translate>Find Device By EAN</translate>
				</v-btn>
			</v-col>
			<v-col
				class="d-flex"
				xs12
				sm6
			>
				<v-btn
					variant="outlined"
					block
					@click="byEan = false"
				>
					<translate>Search For Device</translate>
				</v-btn>
			</v-col>
		</v-row>
		<v-row v-if="byEan">
			<v-col
				class="d-flex"
			>
				<v-text-field
					v-model="ean"
					label="EAN"
					variant="outlined"
				/>
			</v-col>
			<v-col
				class="d-flex"
			>
				<v-select
					:items="[deviceName]"
					:label="$gettext('Device Name')"
					:model-value="deviceName"
					variant="outlined"
					disabled
				/>
			</v-col>

			<v-col
				v-if="searchLoading"
				class="text-center loader"
			>
				<div class="load">
					<v-progress-circular
						indeterminate
						color="primary"
					/>
				</div>
			</v-col>

			<v-col v-else>
				<v-btn
					class="d-flex align-center"
					color="primary"
					@click="findDevice"
				>
					<translate>Find Device</translate>
				</v-btn>
			</v-col>
		</v-row>
		<v-row v-else>
			<v-col
				class="d-flex"
				xs12
			>
				<device-name-search
					ref="deviceSearch"
					v-model:loading="searchLoading"
					clearable
					variant="outlined"
					:label="`${$gettext('Search For Device')}...`"
					@input="selectDevice"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import axios from 'axios';
import {
	displayError,
} from 'laravel-front-library';

/**
 * Useful component for exposing search functionality on deviceDb.
 */
export default {
	name: 'DeviceSearch',

	emits: ['update:modelValue', 'ean-active', 'ean-state',],

	data () {
		return {
			byEan: false,
			searchLoading: false,
			deviceName: '',
			ean: ''
		};
	},

	watch: {
		/**
		 * @param {string} val
		 */
		byEan (val) {
			this.$emit('ean-active', val);
		},

		/**
		 * @param {string} val
		 */
		ean (val) {
			this.$emit('ean-state', val);
		}
	},

	methods: {
		displayError,

		/**
		 * @param {number} deviceId
		 */
		selectDevice (deviceId) {
			this.$emit('update:modelValue', deviceId);
		},

		/**
		 * To reset data.
		 *
		 * @returns {void}
		 */
		reset () {
			this.deviceName = '';
			this.searchLoading = false;
			if (this.$refs.deviceSearch) {
				this.$refs.deviceSearch.reset();
			}
		},

		/**
		 * To call the endpoint which gives the device with a given EAN.
		 *
		 * @returns {void}
		 */
		findDevice () {
			this.findDeviceLoading = true;
			axios
				.get('/bo/orders/device', {
					params: {
						ean: this.ean,
					},
				})
				.then((response) => {
					this.selectDevice(response.data.id);
					this.deviceName = response.data.full_name;
					this.findDeviceLoading = false;
				})
				.catch((error) => {
					this.reset();
					displayError(error.response.data);
					this.findDeviceLoading = false;
				});
		},
	},
};
</script>

<style scoped>

</style>
